import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PedidoDRPLucroLiquidoBadgeComponent } from './pedido-drp-lucro-liquido-badge.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PedidoDRPLucroLiquidoBadgeComponent
    ],
    exports: [
        PedidoDRPLucroLiquidoBadgeComponent
    ]
})
export class PedidoDRPLucroLiquidoBadgeModule { }
